const wowApp = require('angular').module('wowApp.wallet');

const { paypalBaseComponentDefinition } = require('./paypal-base.component');

wowApp.component('wowPaypalBase', paypalBaseComponentDefinition);



// WEBPACK FOOTER //
// ./src/wallet/paypal/index.js